<template>
	<div class="resetpasswordphone">
		<el-container>
			<div class="main">
				<div class="pos_icon">
					<div class="icon icon1"><img src="../../static/img/login2/registerPhone1.png" alt=""></div>
					<el-select slot="prepend" v-model="select" :placeholder="$t('login.areaCode')" class="change">
						<el-option v-for="(item,index) in cities" :key="index" :label="item.telShowCode" :value="item.telCode" class="list">
							<span style="float: left">{{ item.telShowCode}}</span>
							<span style="float: right; color: #8492a6; font-size: 13px">{{ item.language }}</span></el-option>
					</el-select>
				</div>
				<div class="pos_icon">
					<div class="icon icon1"><img src="../../static/img/login2/registerPhone2.png" alt=""></div>
					<el-input v-model='phonenumber' :placeholder="$t('forgetpassword.EnterPhone')" class="input-with-select" @change="phoneVerification">
					</el-input>
				</div>
				<p class="danger" v-show="flag5">{{$t('forgetpassword.FalsePhone')}}</p>
				<p class="danger" v-show="flag6">{{$t('forgetpassword.NoPhone')}}</p>
				<p class="danger" v-show="flag9">{{$t('forgetpassword.NotPhone')}}</p>
				<div class="yanzheng pos_icon">
					<div class="icon icon1"><img src="../../static/img/login2/registerPhone3.png" alt=""></div>
					<el-input :placeholder="$t('login.entercode')" v-model="input4" clearable class="">
					</el-input>
					<el-button class="get" @click="send" ref='banner' :disabled='forbidden'>{{msg}}</el-button>
					<p class="danger" v-show="flag7">{{$t('forgetpassword.NotCode')}}</p>
					<p class="danger" v-show="flag8">{{$t('forgetpassword.NoMatch')}}</p>
				</div>
				
  				<router-link to="/login" class="had"><p>{{$t('forgetpassword.HadAccount')}}</p></router-link>
  				<el-button class="next" @click="next">{{$t('forgetpassword.next')}}</el-button>
				<div class="privacy">
					{{$t('login.agree')}}<router-link to="/privacyStatement">{{$t('login.privacyStatement')}}</router-link>
				</div>
			</div>
		</el-container>
	</div>
</template>

<script>
	import { Verification } from "../api/index.js";
	import { registerByMobile,email,vaildSmsCode } from "../api/index.js";
	import { userLogin } from "../api/index.js";
	import { areaCode } from "../apiNew/index.js";
	import store from "../store/store.js";
	import Qs from "qs";
	import axios from "axios";
	export default {
		name: 'registerphone',
		data() {
			return {
				flag5: false,
				flag6: false,
				flag7: false,
				flag8: false,
				flag9: false,
				forbidden: false,
				msg:this.$t('forgetpassword.verify'),
				cmsg:this.$t('forgetpassword.verify'),
				rmsg:this.$t('forgetpassword.resend'),
				input4:"",
				select: "",
				timer: 0,
				count: 60,
				phonenumber: "",
				value:"",
				cities: [{
						value: "+86",
						label: this.$t('countries.china')
					},
					{
						value: "+852",
						label: this.$t('countries.hongkong')
					},
					{
						value: "+853",
						label: this.$t('countries.macau')
					},
					{
						value: "+886",
						label: this.$t('countries.taiwan')
					},
					{
						value: "+001",
						label: this.$t('countries.America')
					},
					{
						value: "+49",
						label: this.$t('countries.Germany')
					},
					{
						value: "+81",
						label: this.$t('countries.Japan')
					}
					// {
					// 	value: "+355",
					// 	label: this.$t('countries.Albania')
					// },
					// {
					// 	value: "+213",
					// 	label: this.$t('countries.Algeria')
					// },
					// {
					// 	value: "+93",
					// 	label: this.$t('countries.Afghanistan')
					// },
					// {
					// 	value: "+54",
					// 	label: this.$t('countries.Argentina')
					// },
					// {
					// 	value: "+971",
					// 	label: this.$t('countries.UnitedArabemirates')
					// },
					// {
					// 	value: "+297",
					// 	label: this.$t('countries.Aruba')
					// },
					// {
					// 	value: "+968",
					// 	label: this.$t('countries.Oman')
					// },
					// {
					// 	value: "+994",
					// 	label: this.$t('countries.azerbaijan')
					// },
					// {
					// 	value: "+20",
					// 	label: this.$t('countries.Egypt')
					// },
					// {
					// 	value: "+251",
					// 	label: this.$t('countries.Ethiopia')
					// },
					// {
					// 	value: "+353",
					// 	label: this.$t('countries.Ireland')
					// },
					// {
					// 	value: "+372",
					// 	label: this.$t('countries.Estonia')
					// },
					// {
					// 	value: "+376",
					// 	label: this.$t('countries.Andorra')
					// },
					// {
					// 	value: "+244",
					// 	label: this.$t('countries.Angola')
					// },
					// {
					// 	value: "+1264",
					// 	label: this.$t('countries.anguilla')
					// },
					// {
					// 	value: "+1268",
					// 	label: this.$t('countries.AntiguaAndBarbuda')
					// },
					// {
					// 	value: "+43",
					// 	label: this.$t('countries.Austria')
					// },
					// {
					// 	value: "+61",
					// 	label: this.$t('countries.Australia')
					// },
					// {
					// 	value: "+1246",
					// 	label: this.$t('countries.Barbados')
					// },
					// {
					// 	value: "+675",
					// 	label: this.$t('countries.PapuaNewGuinea')
					// },
					// {
					// 	value: "+1242",
					// 	label: this.$t('countries.Bahamas')
					// },
					// {
					// 	value: "+92",
					// 	label: this.$t('countries.Pakistan')
					// },
					// {
					// 	value: "+595",
					// 	label: this.$t('countries.Paraguay')
					// },
					// {
					// 	value: "+970",
					// 	label: this.$t('countries.Palestine')
					// },
					// {
					// 	value: "+973",
					// 	label: this.$t('countries.bahrain')
					// },
					// {
					// 	value: "+507",
					// 	label: this.$t('countries.panama')
					// },
					// {
					// 	value: "+55",
					// 	label: this.$t('countries.Brazil')
					// },
					// {
					// 	value: "+375",
					// 	label: this.$t('countries.belarus')
					// },
					// {
					// 	value: "+1441",
					// 	label: this.$t('countries.Bermuda')
					// },
					// {
					// 	value: "+359",
					// 	label: this.$t('countries.Bulgaria')
					// },
					// {
					// 	value: "+850",
					// 	label: this.$t('countries.NorthKorea')
					// },
					// {
					// 	value: "+1670",
					// 	label: this.$t('countries.NorthernMarianaIslands')
					// },
					// {
					// 	value: "+229",
					// 	label: this.$t('countries.BacNinh')
					// },
					// {
					// 	value: "+32",
					// 	label: this.$t('countries.Belgium')
					// },
					// {
					// 	value: "+354",
					// 	label: this.$t('countries.Iceland')
					// },
					// {
					// 	value: "+1787",
					// 	label: this.$t('countries.PuertoRico')
					// },
					// {
					// 	value: "+48",
					// 	label: this.$t('countries.Poland')
					// },
					// {
					// 	value: "+387",
					// 	label: this.$t('countries.BosniaAndHerzegovina')
					// },
					// {
					// 	value: "+591",
					// 	label: this.$t('countries.Bolivia')
					// },
					// {
					// 	value: "+501",
					// 	label: this.$t('countries.Belize')
					// },
					// {
					// 	value: "+267",
					// 	label: this.$t('countries.BozWana')
					// },
					// {
					// 	value: "+975",
					// 	label: this.$t('countries.Bhutan')
					// },
					// {
					// 	value: "+226",
					// 	label: this.$t('countries.BurkinaFaso')
					// },
					// {
					// 	value: "+257",
					// 	label: this.$t('countries.Burundi')
					// },
					// {
					// 	value: "+240",
					// 	label: this.$t('countries.EquatorialGuinea')
					// },
					// {
					// 	value: "+45",
					// 	label: this.$t('countries.Denmark')
					// },
					// {
					// 	value: "+670",
					// 	label: this.$t('countries.EastTimor')
					// },
					// {
					// 	value: "+228",
					// 	label: this.$t('countries.Togo')
					// },
					// {
					// 	value: "+1767",
					// 	label: this.$t('countries.Dominica')
					// },
					// {
					// 	value: "+1809",
					// 	label: this.$t('countries.DominicanRepublic')
					// },
					// {
					// 	value: "+007",
					// 	label: this.$t('countries.Russia')
					// },
					// {
					// 	value: "+593",
					// 	label: this.$t('countries.Ecuador')
					// },
					// {
					// 	value: "+291",
					// 	label: this.$t('countries.eritrea')
					// },
					// {
					// 	value: "+33",
					// 	label: this.$t('countries.France')
					// },
					// {
					// 	value: "+298",
					// 	label: this.$t('countries.TheFaroeIslands')
					// },
					// {
					// 	value: "+689",
					// 	label: this.$t('countries.FrenchPolynesia')
					// },
					// {
					// 	value: "+379",
					// 	label: this.$t('countries.Vatican')
					// },
					// {
					// 	value: "+63",
					// 	label: this.$t('countries.ThePhilippines')
					// },
					// {
					// 	value: "+679",
					// 	label: this.$t('countries.Fiji')
					// },
					// {
					// 	value: "+358",
					// 	label: this.$t('countries.Finland')
					// },
					// {
					// 	value: "+238",
					// 	label: this.$t('countries.CapeVerde')
					// },
					// {
					// 	value: "+500",
					// 	label: this.$t('countries.Franks')
					// },
					// {
					// 	value: "+220",
					// 	label: this.$t('countries.Gambia')
					// },
					// {
					// 	value: "+242",
					// 	label: this.$t('countries.Congo')
					// },
					// {
					// 	value: "+243",
					// 	label: this.$t('countries.Congo')
					// },
					// {
					// 	value: "+57",
					// 	label: this.$t('countries.Colombia')
					// },
					// {
					// 	value: "+506",
					// 	label: this.$t('countries.CostaRica')
					// },
					// {
					// 	value: "+1473",
					// 	label: this.$t('countries.grenada')
					// },
					// {
					// 	value: "+299",
					// 	label: this.$t('countries.Greenland')
					// },
					// {
					// 	value: "+955",
					// 	label: this.$t('countries.Georgia')
					// },
					// {
					// 	value: "+53",
					// 	label: this.$t('countries.Cuba')
					// },
					// {
					// 	value: "+1671",
					// 	label: this.$t('countries.Guam')
					// },
					// {
					// 	value: "+592",
					// 	label: this.$t('countries.Guyana')
					// },
					// {
					// 	value: "+7",
					// 	label: this.$t('countries.kazakhstan')
					// },
					// {
					// 	value: "+509",
					// 	label: this.$t('countries.Haiti')
					// },
					// {
					// 	value: "+82",
					// 	label: this.$t('countries.Korea')
					// },
					// {
					// 	value: "+31",
					// 	label: this.$t('countries.Netherlands')
					// },
					// {
					// 	value: "+599",
					// 	label: this.$t('countries.NetherlandsAntilles')
					// },
					// {
					// 	value: "+382",
					// 	label: this.$t('countries.Montenegro')
					// },
					// {
					// 	value: "+504",
					// 	label: this.$t('countries.Honduras')
					// },
					// {
					// 	value: "+686",
					// 	label: this.$t('countries.Kiribati')
					// },
					// {
					// 	value: "+253",
					// 	label: this.$t('countries.djibouti')
					// },
					// {
					// 	value: "+996",
					// 	label: this.$t('countries.kyrgyzstan')
					// },
					// {
					// 	value: "+224",
					// 	label: this.$t('countries.guinea')
					// },
					// {
					// 	value: "+1",
					// 	label: this.$t('countries.Canada')
					// },
					// {
					// 	value: "+223",
					// 	label: this.$t('countries.Ghana')
					// },
					// {
					// 	value: "+241",
					// 	label: this.$t('countries.Gabon')
					// },
					// {
					// 	value: "+855",
					// 	label: this.$t('countries.Cambodia')
					// },
					// {
					// 	value: "+420",
					// 	label: this.$t('countries.CzechRepublic')
					// },
					// {
					// 	value: "+263",
					// 	label: this.$t('countries.Zimbabwe')
					// },
					// {
					// 	value: "+237",
					// 	label: this.$t('countries.Cameroon')
					// },
					// {
					// 	value: "+974",
					// 	label: this.$t('countries.Qatar')
					// },
					// {
					// 	value: "+1345",
					// 	label: this.$t('countries.CaymanIslands')
					// },
					// {
					// 	value: "+269",
					// 	label: this.$t('countries.Comorin')
					// },
					// {
					// 	value: "+965",
					// 	label: this.$t('countries.Kuwait')
					// },
					// {
					// 	value: "+385",
					// 	label: this.$t('countries.Croatia')
					// },
					// {
					// 	value: "+254",
					// 	label: this.$t('countries.Kenya')
					// },
					// {
					// 	value: "+682",
					// 	label: this.$t('countries.cookIslands')
					// },
					// {
					// 	value: "+371",
					// 	label: this.$t('countries.Latvia')
					// },
					// {
					// 	value: "+266",
					// 	label: this.$t('countries.Lesotho')
					// },
					// {
					// 	value: "+856",
					// 	label: this.$t('countries.Laos')
					// },
					// {
					// 	value: "+370",
					// 	label: this.$t('countries.Lithuania')
					// },
					// {
					// 	value: "+231",
					// 	label: this.$t('countries.Liberia')
					// },
					// {
					// 	value: "+218",
					// 	label: this.$t('countries.Libya')
					// },
					// {
					// 	value: "+423",
					// 	label: this.$t('countries.Liechtenstein')
					// },
					// {
					// 	value: "+262",
					// 	label: this.$t('countries.reunion')
					// },
					// {
					// 	value: "+352",
					// 	label: this.$t('countries.Luxembourg')
					// },
					// {
					// 	value: "+250",
					// 	label: this.$t('countries.Rwanda')
					// },
					// {
					// 	value: "+40",
					// 	label: this.$t('countries.Romania')
					// },
					// {
					// 	value: "+261",
					// 	label: this.$t('countries.Madagascar')
					// },
					// {
					// 	value: "+960",
					// 	label: this.$t('countries.Maldives')
					// },
					// {
					// 	value: "+356",
					// 	label: this.$t('countries.Malta')
					// },
					// {
					// 	value: "+265",
					// 	label: this.$t('countries.Malawi')
					// },
					// {
					// 	value: "+60",
					// 	label: this.$t('countries.Malaysia')
					// },
					// {
					// 	value: "+389",
					// 	label: this.$t('countries.Macedonia')
					// },
					// {
					// 	value: "+692",
					// 	label: this.$t('countries.MarshallIslands')
					// },
					// {
					// 	value: "+230",
					// 	label: this.$t('countries.Mauritius')
					// },
					// {
					// 	value: "+222",
					// 	label: this.$t('countries.Mauritania')
					// },
					// {
					// 	value: "+1684",
					// 	label: this.$t('countries.AmericanSamoa')
					// },
					// {
					// 	value: "+976",
					// 	label: this.$t('countries.Mongolia')
					// },
					// {
					// 	value: "+1664",
					// 	label: this.$t('countries.Montserrat')
					// },
					// {
					// 	value: "+880",
					// 	label: this.$t('countries.Bangladesh')
					// },
					// {
					// 	value: "+51",
					// 	label: this.$t('countries.Peru')
					// },
					// {
					// 	value: "+691",
					// 	label: this.$t('countries.Micronesia')
					// },
					// {
					// 	value: "+95",
					// 	label: this.$t('countries.Burma')
					// },
					// {
					// 	value: "+373",
					// 	label: this.$t('countries.Moldova')
					// },
					// {
					// 	value: "+377",
					// 	label: this.$t('countries.Monaco')
					// },
					// {
					// 	value: "+258",
					// 	label: this.$t('countries.Mozambique')
					// },
					// {
					// 	value: "+52",
					// 	label: this.$t('countries.Mexico')
					// },
					// {
					// 	value: "+264",
					// 	label: this.$t('countries.Namibia')
					// },
					// {
					// 	value: "+27",
					// 	label: this.$t('countries.SouthAfrica')
					// },
					// {
					// 	value: "+211",
					// 	label: this.$t('countries.SouthSudan')
					// },
					// {
					// 	value: "+674",
					// 	label: this.$t('countries.Nauru')
					// },
					// {
					// 	value: "+505",
					// 	label: this.$t('countries.Nicaragua')
					// },
					// {
					// 	value: "+977",
					// 	label: this.$t('countries.Nepal')
					// },
					// {
					// 	value: "+227",
					// 	label: this.$t('countries.Niger')
					// },
					// {
					// 	value: "+234",
					// 	label: this.$t('countries.Nigeria')
					// },
					// {
					// 	value: "+683",
					// 	label: this.$t('countries.niue')
					// },
					// {
					// 	value: "+47",
					// 	label: this.$t('countries.Norway')
					// },
					// {
					// 	value: "+680",
					// 	label: this.$t('countries.Palau')
					// },
					// {
					// 	value: "+351",
					// 	label: this.$t('countries.Portugal')
					// },
					// {
					// 	value: "+46",
					// 	label: this.$t('countries.Sweden')
					// },
					// {
					// 	value: "+41",
					// 	label: this.$t('countries.Switzerland')
					// },
					// {
					// 	value: "+503",
					// 	label: this.$t('countries.Salvador')
					// },
					// {
					// 	value: "+685",
					// 	label: this.$t('countries.Samoa')
					// },
					// {
					// 	value: "+381",
					// 	label: this.$t('countries.Serbia')
					// },
					// {
					// 	value: "+232",
					// 	label: this.$t('countries.SierraLeone')
					// },
					// {
					// 	value: "+221",
					// 	label: this.$t('countries.Senegal')
					// },
					// {
					// 	value: "+357",
					// 	label: this.$t('countries.Cyprus')
					// },
					// {
					// 	value: "+248",
					// 	label: this.$t('countries.Seychelles')
					// },
					// {
					// 	value: "+966",
					// 	label: this.$t('countries.SaudiArabia')
					// },
					// {
					// 	value: "+239",
					// 	label: this.$t('countries.SaoTomeandPrincipe')
					// },
					// {
					// 	value: "+290",
					// 	label: this.$t('countries.SaintHelena')
					// },
					// {
					// 	value: "+1869",
					// 	label: this.$t('countries.SaintKittsAndNevis')
					// },
					// {
					// 	value: "+1758",
					// 	label: this.$t('countries.SaintLucia')
					// },
					// {
					// 	value: "+378",
					// 	label: this.$t('countries.SanMarino')
					// },
					// {
					// 	value: "+508",
					// 	label: this.$t('countries.SaintPierreandMiquelon')
					// },
					// {
					// 	value: "+94",
					// 	label: this.$t('countries.SriLanka')
					// },
					// {
					// 	value: "+421",
					// 	label: this.$t('countries.Slovakia')
					// },
					// {
					// 	value: "+386",
					// 	label: this.$t('countries.Slovenia')
					// },
					// {
					// 	value: "+268",
					// 	label: this.$t('countries.Swaziland')
					// },
					// {
					// 	value: "+249",
					// 	label: this.$t('countries.Sudan')
					// },
					// {
					// 	value: "+597",
					// 	label: this.$t('countries.Surinam')
					// },
					// {
					// 	value: "+677",
					// 	label: this.$t('countries.SolomonIslands')
					// },
					// {
					// 	value: "+992",
					// 	label: this.$t('countries.Tajikistan')
					// },
					// {
					// 	value: "+66",
					// 	label: this.$t('countries.Thailand')
					// },
					// {
					// 	value: "+255",
					// 	label: this.$t('countries.Tanzania')
					// },
					// {
					// 	value: "+676",
					// 	label: this.$t('countries.Tonga')
					// },
					// {
					// 	value: "+216",
					// 	label: this.$t('countries.Tunisia')
					// },
					// {
					// 	value: "+688",
					// 	label: this.$t('countries.Tuvalu')
					// },
					// {
					// 	value: "+90",
					// 	label: this.$t('countries.Turkey')
					// },
					// {
					// 	value: "+993",
					// 	label: this.$t('countries.Turkmenistan')
					// },
					// {
					// 	value: "+690",
					// 	label: this.$t('countries.Tokelau')
					// },
					// {
					// 	value: "+678",
					// 	label: this.$t('countries.Vanuatu')
					// },
					// {
					// 	value: "+502",
					// 	label: this.$t('countries.Guatemala')
					// },
					// {
					// 	value: "+58",
					// 	label: this.$t('countries.Venezuela')
					// },
					// {
					// 	value: "+673",
					// 	label: this.$t('countries.Brunei')
					// },
					// {
					// 	value: "+256",
					// 	label: this.$t('countries.Uganda')
					// },
					// {
					// 	value: "+380",
					// 	label: this.$t('countries.Ukraine')
					// },
					// {
					// 	value: "+598",
					// 	label: this.$t('countries.Uruguay')
					// },
					// {
					// 	value: "+998",
					// 	label: this.$t('countries.Uzbekistan')
					// },
					// {
					// 	value: "+34",
					// 	label: this.$t('countries.Spain')
					// },
					// {
					// 	value: "+212",
					// 	label: this.$t('countries.WesternSahara')
					// },
					// {
					// 	value: "+30",
					// 	label: this.$t('countries.Greek')
					// },
					// {
					// 	value: "+65",
					// 	label: this.$t('countries.Singapore')
					// },
					// {
					// 	value: "+687",
					// 	label: this.$t('countries.NewCaledonia')
					// },
					// {
					// 	value: "+64",
					// 	label: this.$t('countries.NewZealand')
					// },
					// {
					// 	value: "+36",
					// 	label: this.$t('countries.Hungary')
					// },
					// {
					// 	value: "+963",
					// 	label: this.$t('countries.Syria')
					// },
					// {
					// 	value: "+1876",
					// 	label: this.$t('countries.Jamaica')
					// },
					// {
					// 	value: "+374",
					// 	label: this.$t('countries.Armenia')
					// },
					// {
					// 	value: "+967",
					// 	label: this.$t('countries.Yemen')
					// },
					// {
					// 	value: "+964",
					// 	label: this.$t('countries.irap')
					// },
					// {
					// 	value: "+98",
					// 	label: this.$t('countries.Iran')
					// },
					// {
					// 	value: "+972",
					// 	label: this.$t('countries.Israel')
					// },
					// {
					// 	value: "+39",
					// 	label: this.$t('countries.Italy')
					// },
					// {
					// 	value: "+91",
					// 	label: this.$t('countries.India')
					// },
					// {
					// 	value: "+62",
					// 	label: this.$t('countries.Indonesia')
					// },
					// {
					// 	value: "+44",
					// 	label: this.$t('countries.England')
					// },
					// {
					// 	value: "+1284",
					// 	label: this.$t('countries.BVI')
					// },
					// {
					// 	value: "+246",
					// 	label: this.$t('countries.BIOT')
					// },
					// {
					// 	value: "+962",
					// 	label: this.$t('countries.Jordan')
					// },
					// {
					// 	value: "+84",
					// 	label: this.$t('countries.Vietnam')
					// },
					// {
					// 	value: "+260",
					// 	label: this.$t('countries.Zambia')
					// },
					// {
					// 	value: "+235",
					// 	label: this.$t('countries.Chad')
					// },
					// {
					// 	value: "+350",
					// 	label: this.$t('countries.Gibraltar')
					// },
					// {
					// 	value: "+56",
					// 	label: this.$t('countries.Chile')
					// },
					// {
					// 	value: "+236",
					// 	label: this.$t('countries.CentralAfricanRepublic')
					// }
				]
			}
		},
		mounted() {
			if(sessionStorage.getItem("time")) {
				let count1 = sessionStorage.getItem("time");
				this.timer = setInterval(() => {
					count1--;
					this.msg = this.rmsg + count1 + "S";
					this.forbidden = true;
					this.count = count1;
					sessionStorage.setItem("time", count1);
					if(this.count == 0) {
						this.msg = this.cmsg;
						this.count = 60;
						clearInterval(this.timer);
						this.forbidden = false;
						sessionStorage.removeItem("time", count1);
					}
				}, 1000);
			}
			this.getareaCode()
		},
		methods: {
			//获取国家或地区区号
			getareaCode(){
				let params = Qs.stringify({
					lang: localStorage.getItem("locale")
				})
				areaCode(params)
				.then(res=>{
					this.cities = res.data.data
				})
				.catch(err=>{
					console.log("获取区号错误：",err)
				})
			},
			phoneVerification() {
				//flag5——手机不正确
				//flag6——手机未注册
				//flag7——验证码不能为空
				//flag8——验证码错误！
				//flag9——手机号为空
				let reg1 = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/;
				// if(reg1.test(this.phonenumber)) {
				if(this.phonenumber){
					var params=Qs.stringify({
						account: this.phonenumber
					});
					email(params)//判断用户是否存在
					.then(res=>{
						console.log("email:",res)
						if(res.data.data==true){
							this.flag6=false;
							this.flag5 = false;
							this.flag7=false;
							this.flag8=false;
							this.flag9 = false;
							var params=Qs.stringify({
								mobile: this.phonenumber,
								nativeCode:this.select
							});
						}else{
							this.flag6=true;
							this.flag5 = false;
							this.flag9 = false;
							this.flag7=false;
							this.flag8=false;
						}
					})
					.catch(error=>{
						console.log(error)
					})
				} else {
					if(this.phonenumber.length == 0) {
						this.flag6 = false;
						this.flag9 = true;
						this.flag5 = false;
						this.flag7=false;
						this.flag8=false;
					}
					// else{
					// 	this.flag5 = true;
					// 	this.flag6 = false;
					// 	this.flag9 = false;
					// 	this.flag7=false;
					// 	this.flag8=false;
					// }
					
				}
				
			},
			//下一步
			next(){
				let reg1 = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/;
				// if(reg1.test(this.phonenumber)){
				if(this.phonenumber){
					if(this.input4.length==0){
						this.flag7=true;
					}
					var params=Qs.stringify({
						smsCode: this.input4
					});
					vaildSmsCode(params)//验证验证码
					.then(res=>{
						console.log("next:",res)
						if(res.data.header.status==1000){
							this.flag7=false;
							this.flag8=false;
							this.$router.push({path:'/resetpassword',query:{
								phone:this.phonenumber,
								smsCode:this.input4,
								areaCode:this.value
								}
							})
						};
						if(res.data.header.status==3011){
							this.flag7=true;
							this.flag8=false;
						}
						if(res.data.header.status==3014){
							this.flag7=false;
							this.flag8=true;
						}
					})
					.catch(error=>{
						console.log(error)
					})
				}else{
					if(this.phonenumber.length==0){
						this.flag9=true;
					}
					
				}
				// var params=Qs.stringify({
				// 	smsCode: this.input4
				// });
				// vaildSmsCode(params)//验证验证码
				// .then(res=>{
				// 	console.log("next:",res)
				// 	if(res.data.header.status==1000){
				// 		this.flag7=false;
				// 		this.flag8=false;
				// 		this.$router.push({path:'/resetpassword',query:{
				// 			phone:this.phonenumber,
				// 			smsCode:this.input4
				// 			}
				// 		})
				// 	};
				// 	if(res.data.header.status==3011){
				// 		this.flag7=true;
				// 		this.flag8=false;
				// 	}
				// 	if(res.data.header.status==3014){
				// 		this.flag7=false;
				// 		this.flag8=true;
				// 	}
				// })
				// .catch(error=>{
				// 	console.log(error)
				// })
			},
			//发送验证码
			send() {
				let reg1 = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/;
				// if(reg1.test(this.phonenumber)) {
				if(this.phonenumber) {
					this.flag5 = false;
					var params=Qs.stringify({
						account: this.phonenumber
					});
					email(params)//判断用户是否存在
					.then(res=>{
						console.log("email:",res)
						if(res.data.data==true){
							this.flag6=false;
							this.flag7=false;
							this.flag8=false;
							//点击验证时间
							this.timer = setInterval(() => {
								if (this.count == 0) {
								// this.msg = "点击验证";
								this.msg=this.cmsg;
								this.count = 60;
								clearInterval(this.timer);
								this.forbidden = false;
								sessionStorage.removeItem("time", this.count);
								} else {
								this.count--;
								// this.msg = "重新发送" + this.count + "S";
								this.msg=this.rmsg + this.count + "S";
								this.forbidden = true;
								sessionStorage.setItem("time", this.count);
								}
							}, 1000);

							var params=Qs.stringify({
								mobile: this.phonenumber,
								nativeCode:this.select
							});
							Verification(params)//发送验证码
							.then(res=>{
								console.log("Verification:",res)
								if(res.data.header.status==1000){
									console.log('短信发送成功:',res.data.header.status)
								}
								if(res.data.header.status==3015){
									this.$message({
										message:this.$t('forgetpassword.notresend'),
										type:'warning'
									})
								}

							})
							.catch(error=>{
								console.log(error)
							})
						}else{
							this.flag6=true
						}
							
					})
					.catch(error=>{
						console.log(error)
					})
				} else {
					if(this.phonenumber.length == 0){
						this.flag9=true;
						this.flag6=false;
						this.flag7=false;
						this.flag8=false;
					}
					// else{
					// 	this.flag5 = true;
					// 	this.flag6=false;
					// 	this.flag9=false;
					// 	this.flag7=false;
					// 	this.flag8=false;
					// }
				}
			}
		}
	}
</script>
<style>
.resetpasswordphone .el-input input{
	border: 0;
	border-bottom: 1px solid #cccccc;
	border-radius: 0;
	box-sizing: border-box;
	padding-left: 2.5rem;
}
</style>
<style scoped>
	.main{
		width: 100%;
		padding: 0 0;
	}
	.resetpasswordphone{
		margin-top: 30px;
	}
	.pos_icon{
		position: relative;
		width: 100%;
		height: 2.6rem;
		line-height: 2.6rem;
		margin-top: 20px;
	}
	.icon{
		position: absolute;
		z-index: 99;
		width: 2rem;
		height: 1.5rem;
		line-height: 1.5rem;
		border-right: 1px solid #cccccc;
		top: 0.5rem;
	}
	.icon img{
		width: 1rem;
		vertical-align: middle;
	}


	.change {
		width: 100%;
	}
	
	a {
		color: white;
	}
	
	
	.get {
		width: 6rem;
		position: absolute;
		z-index: 999;
		top: 0;
		right: 0;
		padding: 0;
		height: 2rem;
		line-height: 2rem;
		color: #7dc3f2;
		box-sizing: border-box;
		border: 1px solid #7dc3f2;
		border-radius: 8px;	
	}
	.get.el-button.is-disabled{
		color: #c0c4cc;
		background-color: #ffffff;
	}
	.yanzheng {
		width: 100%;
		position: relative;
	}
	
	.danger {
		font-size: 0.625rem;
		margin-top: 5px;
		color: red;
	}
	
	.list {
		width: 250px;
	}
	.next{
		width: 72%;
		margin-left: 14%;
		font-size: 1rem;
		height: 2.6rem;
		line-height: 2.6rem;
		color: rgb(255,255,255);
		margin-top: 30px;
		border-radius: 1.3rem;
		background-image: linear-gradient(to right , #65d3e8, #7dc3f2);
		border: 0;
		padding: 0 0;
	}
	.next p{
		line-height: 2.5rem;
		color: rgb(255,255,255);
		background: #095196;
		border-radius: 5px;
	}
	.had{
		display: block;
		width: 90%;
		margin: 0 auto;
		color: #7dc3f2;
		font-size: 0.5rem;
		text-align: right;
		margin-top: 20px;
	}
	.privacy{
		width: 90%;
		margin: 0 auto;
		text-align: right;
		font-size: 0.6rem;
		color: #65d3e8;
		letter-spacing: 2px;
		margin-top: 20px;
	}
	.privacy a{
		color: #f17f10;
		border-bottom: 1px solid#f17f10;
	}
</style>


// WEBPACK FOOTER //
// src/components/resetpasswordphone.vue